module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dof-side-nav weex-ct weex-div",
    style: (_vm._px2rem(_vm.sideNavStyle, 75)),
    attrs: {
      "weex-type": "div"
    }
  }, [_c('scroller', [_c('div', {
    staticClass: "list-box weex-ct weex-div",
    attrs: {
      "weex-type": "div"
    }
  }, _vm._l((_vm.items), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "item-box weex-ct weex-div",
      style: (_vm._px2rem(_vm.defaultItemStyle, 75)),
      attrs: {
        "weex-type": "div",
        "data-evt-click": ""
      },
      on: {
        "click": _vm.$stopOuterA,
        "weex$tap": function($event) {
          $event.stopPropagation();
          return _vm.dofItemClick(item, index)
        }
      }
    }, [_c('p', {
      staticClass: "item-text weex-el weex-text",
      style: (_vm.activeIndex == index ? _vm._processExclusiveStyle(_vm.activeTextStyle, 75, 'text') : _vm._processExclusiveStyle(_vm.defaultTextStyle, 75, 'text')),
      attrs: {
        "weex-type": "text"
      }
    }, [_vm._v(_vm._s(item))]), _vm._v(" "), (_vm.activeIndex == index) ? _c('div', {
      staticClass: "active-box weex-ct weex-div",
      style: (_vm._px2rem(_vm.activeBoxStyle, 75)),
      attrs: {
        "weex-type": "div"
      }
    }, [_c('div', {
      staticClass: "line-box weex-ct weex-div",
      style: (_vm._px2rem(_vm.activeLineStyle, 75)),
      attrs: {
        "weex-type": "div"
      }
    })]) : _vm._e()])
  }), 0)])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-20a171e8", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-20a171e8","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/dof-side-nav/index.vue
// module id = 584
// module chunks = 0 1